import React from "react";
import ProductListPage from "./ProductListPage";
import { api } from "../lib/api";
import { useShop } from "../lib/shop-context";

/**
 * Phase 30 — /destacados
 * Phase 32 — scoped to the current shop.
 */
export default function Destacados() {
  const shopCtx = useShop();
  const shop = shopCtx?.shop || "envio";
  return (
    <ProductListPage
      title="Destacados"
      subtitle="Productos seleccionados por MercaGo"
      testid="destacados-page"
      emptyMessage="Aún no hay productos destacados. Márcalos como destacados desde el panel admin."
      fetchFn={() =>
        api
          .get("/products/featured", { params: { limit: 200, shop } })
          .then((r) => r.data)
      }
    />
  );
}
